'use client'
import { useEffect, useRef } from "react"
import { useMap } from "./MapContext"

interface FilterCircleProps {
    center: google.maps.LatLngLiteral
    radius: number
    onCenterChange: (center: google.maps.LatLngLiteral) => void
    onRadiusChange: (radius: number) => void
}

const FilterCircle: React.FC<FilterCircleProps> = ({ center, radius, onCenterChange, onRadiusChange }) => {
    const { map } = useMap()
    const circleRef = useRef<google.maps.Circle | null>(null)

    useEffect(() => {
        if (!map) return

        const circle = new google.maps.Circle({
            map,
            center,
            radius,
            draggable: true,
            editable: true,
            strokeColor: '#3B82F6',
            strokeOpacity: 0.9,
            strokeWeight: 2,
            fillColor: '#3B82F6',
            fillOpacity: 0.12,
            zIndex: 20,
        })

        const centerListener = circle.addListener('center_changed', () => {
            const c = circle.getCenter()
            if (c) onCenterChange({ lat: c.lat(), lng: c.lng() })
        })

        const radiusListener = circle.addListener('radius_changed', () => {
            onRadiusChange(Math.round(circle.getRadius()))
        })

        circleRef.current = circle

        return () => {
            google.maps.event.removeListener(centerListener)
            google.maps.event.removeListener(radiusListener)
            circle.setMap(null)
            circleRef.current = null
        }
    }, [map])

    return null
}

export default FilterCircle
